/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Profile_Session_Minutes_ValueInputs */

const en_us2_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Up to ${i?.minutes} min`)
};

const pt_br2_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Até ${i?.minutes} min`)
};

const es_419_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hasta ${i?.minutes} min`)
};

const pt_pt2_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Até ${i?.minutes} min`)
};

const fr_fr2_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jusqu'à ${i?.minutes} min`)
};

const de_de2_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bis zu ${i?.minutes} min`)
};

const it_it2_profile_session_minutes_value = /** @type {(inputs: Profile_Session_Minutes_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fino a ${i?.minutes} min`)
};

/**
* | output |
* | --- |
* | "Up to {minutes} min" |
*
* @param {Profile_Session_Minutes_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_session_minutes_value = /** @type {((inputs: Profile_Session_Minutes_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Session_Minutes_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_session_minutes_value(inputs)
	if (locale === "es-419") return es_419_profile_session_minutes_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_session_minutes_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_session_minutes_value(inputs)
	if (locale === "de-DE") return de_de2_profile_session_minutes_value(inputs)
	if (locale === "it-IT") return it_it2_profile_session_minutes_value(inputs)
	return en_us2_profile_session_minutes_value(inputs)
});
export { profile_session_minutes_value as "profile.session_minutes_value" }